import { useWebhookLog } from '../hooks'

export function WebhookLogTable({ sourceCode }: { sourceCode: string }) {
  const q = useWebhookLog(sourceCode, 100)

  if (q.isLoading) return <p className="text-sm text-slate-500">Wczytywanie historii...</p>
  if (q.isError) return <p className="text-sm text-red-600">Błąd: {String(q.error)}</p>
  if (!q.data || q.data.length === 0) {
    return <p className="text-sm text-slate-500 italic">Brak wpisów.</p>
  }

  return (
    <table className="w-full text-sm">
      <thead className="text-left text-[11px] uppercase tracking-wide text-slate-500 border-b">
        <tr>
          <th className="py-2 pr-4">Data</th>
          <th className="py-2 pr-4">Status</th>
          <th className="py-2 pr-4">Czas (ms)</th>
          <th className="py-2 pr-4">Encja</th>
          <th className="py-2 pr-4">Błąd</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-100">
        {q.data.map(row => (
          <tr key={row.id}>
            <td className="py-2 pr-4 text-slate-600">
              {new Date(row.receivedAt).toLocaleString('pl-PL')}
            </td>
            <td className="py-2 pr-4">
              <span className={`rounded px-1.5 py-0.5 text-xs ${
                row.responseStatus >= 200 && row.responseStatus < 300
                  ? 'bg-emerald-50 text-emerald-700'
                  : 'bg-rose-50 text-rose-700'
              }`}>{row.responseStatus}</span>
            </td>
            <td className="py-2 pr-4 text-slate-600">{row.processingTimeMs ?? '—'}</td>
            <td className="py-2 pr-4 text-slate-600">
              {row.handledEntityType && row.handledEntityId
                ? `${row.handledEntityType} #${row.handledEntityId}`
                : '—'}
            </td>
            <td className="py-2 pr-4 text-rose-700 text-xs">
              {row.error ? (row.error.length > 80 ? row.error.slice(0, 80) + '…' : row.error) : '—'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
